import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable/Loadable';

const AppIcon = Loadable(lazy(() => import('./icons/AppIcon')));

const materialRoutes = [
  {
    path: '/material/icons',
    element: <AppIcon />,
  },
];

export default materialRoutes;
